import React, {useEffect, useState} from "react";
import {useObserver} from "mobx-react-lite";
import {useStore} from "../../hooks/useStore";
import {useFetch} from "../../hooks/useFetch";
import {Col, List, Row, Skeleton, Card} from "antd";
import {LockOutlined, AuditOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

import {HeaderText, PasswordCard} from "./profileStyles";
import {ChangePasswordForm} from "./ChangePasswordForm/ChangePasswordForm";
import CommunicationPreferencesCard from "../_defaultComponents/CommunicationPreferencesCard/CommunicationPreferencesCard";
import {BillingInformationForm} from "./BillingInformationForm/BillingInformationForm";
import {AuthorizedIDForm} from "./AuthorizedIDForm/AuthorizedIDForm";
import {PaymentInfoForm} from "./PaymentInfoForm/PaymentInfoForm";
import {UserInfoCard} from "./UserInfoCard/UserInfoCard";
import {CustomerInfoCard} from "./CustomerInfoCard/CustomerInfoCard";

export const ProfilePage = () => {
    const stores = useStore();
    const {t} = useTranslation(["profilePage"]);
    const {username, email, company, role} = stores.meStore;
    const [userInfo, setUserInfo] = useState([
        {title: t("fields.username", {ns: "common"}), value: username},
        {title: "E-mail", value: email}
    ]);
    const isCustomer = stores.meStore.checkRole("isCompanyUser");

    const [loading, userProfileInfo, setuserProfileInfo, setLoading, refetch] = useFetch({
        fetchFn: stores.userStore.getUserInfo.bind(null, {})
    });

    useEffect(() => {
        if (["cUser", "oUser", "sOperation", "fieldManager"].includes(role)) {
            const userCompanyInfos = userProfileInfo?.companyInfos;
            const userSubCompanyInfos = userProfileInfo?.subcompanyInfos;

            const newUserInfo = [
                {title: t("fields.username", {ns: "common"}), value: username},
                {title: "E-mail", value: email}
            ];

            if (userCompanyInfos?.length > 0) {
                const companies = userCompanyInfos.map(company => company.companyName).join(", ");
                newUserInfo.push({
                    title: t("fields.companyName", {ns: "common"}),
                    value: companies || t("profilePage.notCompanyAssigned", {ns: "profilePage"})
                });
            }

            if (userSubCompanyInfos?.length > 0) {
                const subCompanies = userSubCompanyInfos
                    .map(subCompany => subCompany.name)
                    .join(", ");
                newUserInfo.push({
                    title: t("fields.subcompanyName", {ns: "common"}),
                    value: subCompanies || t("profilePage.notCompanyAssigned", {ns: "profilePage"})
                });
            }

            setUserInfo(newUserInfo);
        }
    }, [userProfileInfo]);

    return useObserver(() => (
        <Row type="flex" justify="center" data-testid="profileScreen" style={{width: "100%"}}>
            <Col md={24} sm={22}>
                {/* 
                <Card
                    title={
                        <h4>
                            <AuditOutlined />
                            <HeaderText>
                                {t("profilePage.userInfoHeader", {ns: "profilePage"})}
                            </HeaderText>
                        </h4>
                    }
                >
                    <List
                        dataSource={userInfo}
                        renderItem={row => (
                            <List.Item style={styles.listItem}>
                                <Skeleton loading={false} active>
                                    <List.Item.Meta
                                        description={row.title}
                                        style={styles.listItemMeta}
                                    />
                                    <div
                                        data-testid="userInfo"
                                        data-testvalue={row.title}
                                        style={styles.listItemValue}
                                    >
                                        {row.value}
                                    </div>
                                </Skeleton>
                            </List.Item>
                        )}
                        style={styles.list}
                    />
                </Card>
                */}
                <Row gutter={[16, 16]} style={{marginBottom: "20px"}}>
                    <Col md={12} sm={24}>
                        <UserInfoCard username={username} email={email} />
                    </Col>
                    <Col md={12} sm={24}>
                        <CustomerInfoCard userProfileInfo={userProfileInfo} />
                    </Col>
                </Row>
                {isCustomer && (
                    <Row gutter={[16, 16]} style={{marginTop: "20px"}}>
                        <Col md={12} sm={24}>
                            <PaymentInfoForm
                                subCompany={userProfileInfo?.subcompanyInfos?.[0]}
                                loading={loading}
                                refetch={refetch}
                                isCustomer={isCustomer}
                            />
                        </Col>
                        <Col md={12} sm={24}>
                            <AuthorizedIDForm
                                subCompany={userProfileInfo?.subcompanyInfos?.[0]}
                                loading={loading}
                                refetch={refetch}
                                isCustomer={isCustomer}
                            />
                        </Col>
                    </Row>
                )}
                {isCustomer && (
                    <BillingInformationForm
                        subCompany={userProfileInfo?.subcompanyInfos?.[0]}
                        loading={loading}
                        refetch={refetch}
                        isCustomer={isCustomer}
                    />
                )}
                <Row
                    gutter={[8, 8]}
                    style={{
                        marginTop: "10px",
                        overflow: "hidden",
                        borderBottom: "1px solid #f0f0f0"
                    }}
                >
                    <Col md={12} sm={24}>
                        <CommunicationPreferencesCard />
                    </Col>
                    <Col md={12} sm={24}>
                        <PasswordCard
                            title={
                                <h4>
                                    <LockOutlined />
                                    <HeaderText>
                                        {t("profilePage.actions.changePassword", {
                                            ns: "profilePage"
                                        })}
                                    </HeaderText>
                                </h4>
                            }
                        >
                            <ChangePasswordForm isCustomer={isCustomer} />
                        </PasswordCard>
                    </Col>
                </Row>
            </Col>
        </Row>
    ));
};

const styles = {
    list: {
        backgroundColor: "#fff",
        borderRadius: "4px"
    },
    listItem: {
        padding: "12px 0",
        borderBottom: "1px solid #f0f0f0"
    },
    listItemMeta: {
        padding: "10px 20px",
        minWidth: "150px",
        fontWeight: "500",
        color: "#666"
    },
    listItemValue: {
        padding: "10px 20px",
        flex: 1,
        fontWeight: "400",
        color: "#333"
    }
};
